(function () {
  if (window.__AG_PB_STORY_PANELS_INIT__) return;
  window.__AG_PB_STORY_PANELS_INIT__ = true;

  var MOBILE_MAX = 740;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  /* Real slide wrappers as Shopify renders them (loop clones have their ids stripped). */
  var SLIDE_SELECTOR = '.shopify-block, [id^="shopify-block-"]';

  /* Includes loop clones — measurement and scroll positions need the full strip. */
  function getWrappers(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        '.ag-pb-story-panels__track > .shopify-block,' +
        '.ag-pb-story-panels__track > [id^="shopify-block-"],' +
        '.ag-pb-story-panels__track > [data-ag-swipe-clone]'
      )
    );
  }

  /* Loop controller per block root, so dots can map clones back to real slides. */
  var loops = new WeakMap();

  function toDotIndex(root, index) {
    var loop = loops.get(root);
    return loop ? loop.realIndex(index) : index;
  }

  function updateActiveDot(root, index) {
    var dotIndex = toDotIndex(root, index);
    var dots = root.querySelectorAll('.ag-pb-story-panels__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === dotIndex);
      dot.setAttribute('aria-current', i === dotIndex ? 'true' : 'false');
    });
  }

  function scrollToIndex(root, track, wrappers, index, velocityX, onDone) {
    var target = wrappers[index];
    if (!target || !track) return;

    var trackRect = track.getBoundingClientRect();
    var itemRect = target.getBoundingClientRect();
    var offset = itemRect.left - trackRect.left - (trackRect.width - itemRect.width) / 2;
    var left = track.scrollLeft + offset;

    /* Touch releases carry the flick speed into the settle so it coasts instead of
       running the browser's fixed smooth-scroll curve. Dots keep that curve. */
    if (typeof velocityX === 'number' && window.AgPbSwipe && window.AgPbSwipe.glide) {
      window.AgPbSwipe.glide(track, left, { velocityX: velocityX, onDone: onDone });
    } else {
      track.scrollTo({
        left: left,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      if (onDone) window.setTimeout(onDone, 450);
    }

    updateActiveDot(root, index);
  }

  function getClosestIndex(track, wrappers) {
    if (!track || wrappers.length === 0) return 0;

    var trackRect = track.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var closest = 0;
    var closestDistance = Infinity;

    wrappers.forEach(function (wrapper, index) {
      var rect = wrapper.getBoundingClientRect();
      var itemCenter = rect.left + rect.width / 2;
      var distance = Math.abs(center - itemCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function syncActiveFromScroll(root, track, wrappers) {
    if (!track || wrappers.length === 0) return;
    updateActiveDot(root, getClosestIndex(track, wrappers));
  }

  /* Distance between two slide origins — one "advance" worth of travel. */
  function getStep(wrappers) {
    if (!wrappers || wrappers.length < 2) return 0;
    return Math.abs(
      wrappers[1].getBoundingClientRect().left - wrappers[0].getBoundingClientRect().left
    );
  }

  function buildDots(root, track, wrappers) {
    var dotsWrap = root.querySelector('.js-ag-pb-story-panels-dots');
    if (!dotsWrap) return;

    dotsWrap.innerHTML = '';

    if (!isMobile() || wrappers.length <= 1) {
      dotsWrap.hidden = true;
      dotsWrap.setAttribute('aria-hidden', 'true');
      return;
    }

    dotsWrap.hidden = false;
    dotsWrap.removeAttribute('aria-hidden');
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Story panel slides');

    /* One dot per real slide — clones must not add dots of their own. */
    var loop = loops.get(root);
    var dotCount = loop ? loop.realCount : wrappers.length;

    for (var index = 0; index < dotCount; index++) {
      (function (dotIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ag-pb-story-panels__dot' + (dotIndex === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to panel ' + (dotIndex + 1));
        dot.setAttribute('aria-current', dotIndex === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          var current = getWrappers(root);
          var target = dotIndex;

          /* Looping: jump to whichever copy of that slide is nearest. */
          if (loop) {
            var here = getClosestIndex(track, current);
            var offset = loop.realIndex(dotIndex) - loop.realIndex(here);
            var half = loop.realCount / 2;
            if (offset > half) offset -= loop.realCount;
            if (offset < -half) offset += loop.realCount;
            target = Math.max(0, Math.min(here + offset, current.length - 1));
          }

          scrollToIndex(root, track, current, target, undefined, function () {
            if (loop) loop.normalize();
          });
        });
        dotsWrap.appendChild(dot);
      })(index);
    }
  }

  function initBlock(root) {
    if (root.dataset.agPbSpReady === 'true') return;

    var track = root.querySelector('.js-ag-pb-story-panels-track');
    if (!track || getWrappers(root).length === 0) return;

    root.dataset.agPbSpReady = 'true';

    /* Clone the set before anything measures, so dots and positions see the real strip.
       Desktop hides the clones in CSS — at 741+ this is a static 3-column grid. */
    if (root.dataset.agPbLoop === 'true' && window.AgPbSwipe && window.AgPbSwipe.enableLoop) {
      var loop = window.AgPbSwipe.enableLoop(track, { slideSelector: SLIDE_SELECTOR });
      if (loop) {
        loops.set(root, loop);
        loop.reset();
      }
    }

    var wrappers = getWrappers(root);
    buildDots(root, track, wrappers);

    if (root.dataset.agPbAutoscroll === 'true' && window.AgPbSwipe && window.AgPbSwipe.autoScroll) {
      window.AgPbSwipe.autoScroll(track, { speed: parseFloat(root.dataset.agPbAutoscrollSpeed) });
    }

    /* Touch horizontal is JS-driven (CSS drops native h-scroll on coarse pointers).
       Settle on drag intent (distance/velocity) — nearest-slide alone would force a
       >50% swipe to advance, which reads as having to drag the full screen width. */
    if (window.AgPbSwipe) {
      var swipeStartIndex = 0;
      window.AgPbSwipe.bind(track, {
        enabled: isMobile,
        onStart: function () {
          swipeStartIndex = getClosestIndex(track, getWrappers(root));
        },
        onSettle: function (drag) {
          var current = getWrappers(root);
          scrollToIndex(
            root,
            track,
            current,
            window.AgPbSwipe.resolveIndex({
              startIndex: swipeStartIndex,
              count: current.length,
              deltaX: drag.deltaX,
              velocityX: drag.velocityX,
              step: getStep(current),
              fallbackIndex: getClosestIndex(track, current)
            }),
            drag.velocityX,
            /* Re-centre on the middle set once the glide lands, never mid-gesture. */
            function () {
              var activeLoop = loops.get(root);
              if (activeLoop) activeLoop.normalize();
            }
          );
        }
      });
    }

    var scrollRaf = false;
    track.addEventListener('scroll', function () {
      if (!isMobile()) return;
      if (scrollRaf) return;
      scrollRaf = true;
      requestAnimationFrame(function () {
        syncActiveFromScroll(root, track, wrappers);
        scrollRaf = false;
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        buildDots(root, track, getWrappers(root));
      }, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-story-panels').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.js-ag-pb-story-panels').forEach(function (root) {
      delete root.dataset.agPbSpReady;
      initBlock(root);
    });
  });
})();
